import { AlertCircle } from 'lucide-react';

export const NoTabs = () => {
  return (
    <div className="flex flex-col items-center justify-center gap-4 p-6 text-center">
      <div className="pm-fallback-icon">
        <AlertCircle size={48} color="#6c63ff" />
      </div>
      <div className="space-y-2">
        <h2 className="text-xl font-medium">No Inventory data available</h2>
      </div>
    </div>
  );
};
